import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { MOBILE_MAX_UPLOAD_FILES } from 'config'
import { useAlert } from 'hooks/useDialog'
import { ChangeEventHandler } from 'react'

const LIMIT_REACH_MSG = `スマートフォンからの一度にアップロード可能なファイル数は${MOBILE_MAX_UPLOAD_FILES}ファイルとなっています`

export interface PhotoInputProps {
  limitReached: boolean
  onChange: (files: File[]) => void
}

const PhotoInput = ({ limitReached, onChange }: PhotoInputProps) => {
  const alert = useAlert()
  const alertLimitReached = () => {
    alert({ message: LIMIT_REACH_MSG })
  }

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const { files } = event.target
    if (!files || !files.length) {
      return
    }
    onChange([...files])
    event.target.value = ''
  }

  return (
    <label onClick={limitReached ? alertLimitReached : undefined}>
      <Box display="flex" alignItems="center">
        <PhotoLibraryIcon color="primary" fontSize="large" />
        <Box paddingLeft={1}>
          <Typography variant="button">画像を追加</Typography>
        </Box>
      </Box>
      <input
        type="file"
        accept="image/*"
        disabled={limitReached}
        onChange={handleChange}
        style={{ display: 'none' }}
      />
    </label>
  )
}

export default PhotoInput
